wbApp.factory('geoCoderSvc', ['$q', 'uiGmapGoogleMapApi',
    function ($q, uiGmapGoogleMapApi) {

        function geocode(address) {
            var d = $q.defer();

            uiGmapGoogleMapApi.then(function (maps) {
                var geocoder = new maps.Geocoder();

                var addr;
                if (typeof address === 'string' || address instanceof String) {
                    addr = address;
                } else {
                    addr = address.formatted_address;
                }

                geocoder.geocode({ 'address': addr }, function (results, status) {
                    if (status === maps.GeocoderStatus.OK ||
                        status === maps.GeocoderStatus.ZERO_RESULTS) {
                        d.resolve(results);
                    } else {
                        d.reject(status);
                    }
                });
            });

            return d.promise;
        }

        function geoDecode(latitude, longtitude) {
            var d = $q.defer();

            uiGmapGoogleMapApi.then(function (maps) {

                var latlng = new maps.LatLng(latitude, longtitude);
                var geocoder = new maps.Geocoder();
                geocoder.geocode({ 'latLng': latlng }, function (results, status) {
                    if (status === maps.GeocoderStatus.OK ||
                        status === maps.GeocoderStatus.ZERO_RESULTS) {
                        d.resolve(results);
                    } else {
                        d.reject(status);
                    }
                });
            });

            return d.promise;
        }

        return {
            geocode: geocode,
            geoDecode: geoDecode
        }
    }]);